import client from './client';

const companyInfoUrl = '/api/v1/sys/company-info';

/**
 * 회사 정보 조회 (현재 로그인 사용자의 회사)
 * @returns {Promise} 회사 정보
 */
export const getCompanyInfo = () => {
  return client.get(`${companyInfoUrl}/detail`);
};

/**
 * 회사 정보 조회 (회사코드 지정)
 * @param {string} companyCd - 회사 코드
 * @returns {Promise} 회사 정보
 */
export const getCompanyInfoByCode = (companyCd) => {
  return client.get(`${companyInfoUrl}/detail/${companyCd}`);
};

/**
 * 회사 정보 저장 (없으면 생성, 있으면 수정)
 * @param {object} data - 회사 정보
 * @returns {Promise} 저장 결과
 */
export const saveCompanyInfo = (data) => {
  return client.post(`${companyInfoUrl}/save`, data);
};

/**
 * 로고 파일 업로드
 * @param {FormData} formData - 파일 데이터
 * @returns {Promise} 업로드 결과
 */
export const uploadLogo = (formData) => {
  return client.post(`${companyInfoUrl}/upload/logo`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

/**
 * 인감 파일 업로드
 * @param {FormData} formData - 파일 데이터
 * @returns {Promise} 업로드 결과
 */
export const uploadSeal = (formData) => {
  return client.post(`${companyInfoUrl}/upload/seal`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

/**
 * 로고 이미지 Blob URL 조회 (JWT 인증 포함)
 * @returns {Promise<string|null>} Blob URL 또는 null
 */
export const fetchLogoImageBlobUrl = async () => {
  try {
    const response = await client.get(`${companyInfoUrl}/image/logo`, {
      responseType: 'blob',
      params: { t: Date.now() }, // 캐시 버스팅
    });
    if (!response.data || response.data.size === 0) return null;
    return URL.createObjectURL(response.data);
  } catch (e) {
    console.error('[fetchLogoImageBlobUrl] error:', e?.response?.status, e?.message);
    return null;
  }
};

/**
 * 인감 이미지 Blob URL 조회 (JWT 인증 포함)
 * @returns {Promise<string|null>} Blob URL 또는 null
 */
export const fetchSealImageBlobUrl = async () => {
  try {
    const response = await client.get(`${companyInfoUrl}/image/seal`, {
      responseType: 'blob',
      params: { t: Date.now() }, // 캐시 버스팅
    });
    return URL.createObjectURL(response.data);
  } catch {
    return null;
  }
};

/**
 * 회사 정보 삭제
 * @param {string} companyCd - 회사 코드
 * @returns {Promise} 삭제 결과
 */
export const deleteCompanyInfo = (companyCd) => {
  return client.delete(`${companyInfoUrl}/delete/${companyCd}`);
};
